import type { ColumnDef } from "@tanstack/react-table";
import { ISTATUS } from "../../../models/common/CommonModels";
import type {
  RowData,
  TimeSlot,
} from "../../../models/weather/IWeatherForecast";
import { getStylesForStatus } from "../../../utils/common/CommonHelperFunctions";
import ClassLabel from "./ClassLabel";

export function buildGroupedMetricColumns(
  timeSlots: TimeSlot[],
  styles: {
    toggleBtn: string;
    chevron: string;
    chevronExpanded: string;
    cellInner: string;
    cellModerate: string;
    cellPoor: string;
  }
): ColumnDef<RowData>[] {
  const timeCols: ColumnDef<RowData>[] = timeSlots.map((slot, slotIndex) => ({
    id: `time-${slotIndex}`,
    header: slot,
    cell: ({ row }) => {
      const vals = row.original.valueCells;
      if (!vals || !Array.isArray(vals)) return "";

      const cellStatus = row.original.slotStatuses?.[slotIndex];
      const className = getStylesForStatus(
        cellStatus as ISTATUS,
        styles as any
      );

      return <div className={className}>{vals[slotIndex] ?? ""}</div>;
    },
    meta: { align: "center" as const },
  }));

  return [
    {
      id: "class",
      header: "Class",
      cell: ({ row }) => {
        const isGroup = !!row.original.classLabel;
        if (isGroup) {
          const isExpanded = row.getIsExpanded();

          // GROUP ROW: class cell highlighting based on groupStatus
          const className = getStylesForStatus(
            row.original.groupStatus as ISTATUS,
            styles as any
          );

          return (
            <ClassLabel
              row={row}
              isExpanded={isExpanded}
              className={className}
              styles={{
                toggleBtn: styles.toggleBtn,
                chevron: styles.chevron,
                chevronExpanded: styles.chevronExpanded,
              }}
            />
          );
        }

        // CHILD ROW: just the condition label (indented), no toggle, no class highlighting
        const conditionLabel = row.original?.condition ?? "";
        const Unit = row.original?.unit ?? "";
        const formattedUnit = Unit ? `(${Unit})` : "";
        const label = `${conditionLabel} ${formattedUnit}`;
        return (
          <div
            className={styles.cellInner}
            style={{ paddingInlineStart: `48px` }}
          >
            {label}
          </div>
        );
      },
    },
    ...timeCols,
  ];
}
